;(function ($) {
	$.fn.naturataSliders = function () {
		return $(this).each(function () {
			var container = $(this);

			var options = {
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 4,
				slidesToScroll: 4,
				responsive: [
					{
						breakpoint: 1440,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							infinite: true,
							dots: true
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
							dots: true
						}
					}
				]
			};

			if(container.hasClass('ce__stageslider__stage-slider')) {
				options = {
					dots: true,
					infinite: true,
					speed: 300,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: true,
					autoplaySpeed: 10000,
					init: function() {
					    $(window).trigger('resize');
                    }
				};
            }

			if(container.hasClass('product-slider')) {
				options = {
					dots: true,
					infinite: true,
					speed: 300,
					slidesToShow: 3,
					slidesToScroll: 3,
					responsive: [
						{
							breakpoint: 1440,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
								infinite: true,
								dots: true
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								infinite: true,
								dots: true
							}
						}
					]
				};
            }

			if(container.hasClass('product-extended-slider')) {
				options = {
					dots: true,
					infinite: true,
					speed: 300,
					slidesToShow: 4,
					slidesToScroll: 4,
					responsive: [
						{
							breakpoint: 1440,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
								infinite: true,
								dots: true
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								infinite: true,
								dots: true
							}
						}
					]
				};
			}

			if(container.hasClass('media-slider')) {
				options = {
					dots: true,
					infinite: true,
					speed: 300,
					slidesToShow: 1,
					slidesToScroll: 1
				};
			}

			if(container.hasClass('projects-slider')) {
				options = {
					dots: true,
					infinite: true,
					speed: 300,
					slidesToShow: 3,
					slidesToScroll: 3,
					responsive: [
						{
							breakpoint: 1440,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1,
								infinite: true,
								dots: true
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								infinite: true,
								dots: true
							}
						}
					]
				};
			}

			if(container.hasClass('product-category-teaser-slider')) {
				options = {
					dots: true,
					infinite: true,
					speed: 300,
					slidesToShow: 3,
					slidesToScroll: 3,
					responsive: [
						{
							breakpoint: 1440,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
								infinite: true,
								dots: true
							}
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								infinite: true,
								dots: true
							}
						}
					]
				};
            }

			if(!container.hasClass('parallax-slider')) {
				container.slick(options);
			}
		});
	};
	$(function () {
		$('[class$="-slider"]').naturataSliders();
	});
})(jQuery);
